<template>
    <div class="page">
        <header>
            <div :class="getTab1" @click="changeTab(1)">
                <div>全部</div>
                <div class="item-line"><div></div></div>
            </div>

            <div :class="getTab2" @click="changeTab(2)">
                <div>处理中</div>
                <div class="item-line"></div>
            </div>

            <div :class="getTab3" @click="changeTab(3)">
                <div>已完成</div>
                <div class="item-line"></div>
            </div>
        </header> 
        <div class="list-none" v-if="getIsShowNone">
            <img src="../../../assets/list-none.png" alt="">
            <div>空荡荡的~暂无数据！</div>
        </div>

        <main v-else>
            <list-item v-for="item in dataInfo"
                       :key="item.id"
                       :data-info="item">
            </list-item>

            <div class="list-refresh"
                 @click="loadMore">
                点击加载更多
            </div>

        </main>

        <img src="../../../assets/float-add.png"
             class="float-button" alt="" @click="gotoNew" @click.stop.prevent>
    </div>
</template>

<script>
    import ListItem from "./ListItem";
    import wx from "weixin-js-sdk";
    import axios from "axios";
    import {Message} from 'element-ui';
    import randomWord from "../../RandomWord";

    export default {
        name: "List",

        components: {
            ListItem
        },

        data() {
            return {
                selectTab: "1",
                currPage: 0,
                dataInfo: []
            }
        },

        created() {
            document.title = "在线报修";
            this.getInfo();
        },

        methods: {
            changeTab(tab) {
                this.selectTab = tab + "";
                this.currPage = 0;
                this.dataInfo = [];
                this.getInfo();
            },

            gotoNew() {
                wx.miniProgram.getEnv(function() {
                    wx.miniProgram.navigateTo({
                        url: "/pages/report/select"
                    });
                });
            },

            loadMore: function () {
                this.getInfo();
            },

            getInfo() {
                let state = "";
                if (this.selectTab === "1") {
                    state = "all";
                }
                if (this.selectTab === "2") {
                    state = "processing";
                }
                if (this.selectTab === "3") {
                    state = "finished";
                }
                let url = axios.defaults.baseURL.replace('v1/org/','')
                axios({
                    method: 'post',
                    url: url+"v2/users/workorders",
                    headers: {'Authorization': this.$route.query.token},
                    data: {
                        "state": state,
                        "orgID": "",
                        "pageIdx": this.currPage,
                        "pageSize": 5
                    }
                }).then(value => {
                    if (value.data.data) {
                        this.currPage ++;
                        value.data.data.forEach(item => {
                            item.id = randomWord.randomWord(false, 16);
                            this.dataInfo.push(item);
                        });
                    }
                    if (this.dataInfo.length !== 0 && value.data.data.length === 0) {
                        Message.warning("无更多数据")
                    }
                    if (value.data.code !== 0) {
                        Message.error(value.data.message);
                    }
                }).catch((err) => {
                    Message.error(err.toString());
                });
            }
        },

        computed: {

            getTab1() {
                if (this.selectTab === "1") {
                    return "item-select";
                }
                else {
                    return ""
                }
            },

            getTab2() {
                if (this.selectTab === "2") {
                    return "item-select";
                }
                else {
                    return ""
                }
            },

            getTab3() {
                if (this.selectTab === "3") {
                    return "item-select";
                }
                else {
                    return ""
                }
            },

            getIsShowNone() {
                return !(this.dataInfo && this.dataInfo.length > 0);
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../pay/page";

    header {
        z-index: 111;
        justify-content: space-around;
        align-items: center;
        background: white;
        width: 102%;
        display: flex;
        height: 44px;
        position: sticky;
        top: 0;
        >div {
            align-items: center;
            width: 34%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100%;
            position: relative;
        }
        .item-line {
            bottom: 0;
            position: absolute;
            background-color: white;
            height: 2px;
            width: 40px;
        }
        .item-select {
            color: $colorDefault;
            .item-line {
                background-color: $colorDefault;
            }
        }
    }

    main {
        margin-bottom: 100px;
    }

</style>
